(() => {
  const form = document.querySelector('[data-professional-application-form]');
  if (!form) return;
  const endpoint = form.dataset.endpoint;
  const message = form.querySelector('[data-message]');
  const submit = form.querySelector('[data-submit]');
  const state = document.querySelector('[data-professional-application-state]');
  const notice = document.querySelector('[data-professional-access-notice]');
  const panel = document.querySelector('[data-access-application-panel]');
  const requestLink = document.querySelector('[data-access-application-open]');
  const syncApplicationPanel = () => {
    if (!panel || !requestLink) return;
    panel.hidden = window.location.hash !== '#solicitar-acceso';
    requestLink.setAttribute('aria-expanded', String(!panel.hidden));
    if (!panel.hidden) panel.scrollIntoView({block: 'start'});
  };
  if (panel && requestLink) {
    requestLink.addEventListener('click', () => {
      panel.hidden = false;
      requestLink.setAttribute('aria-expanded', 'true');
      if (window.location.hash === '#solicitar-acceso') panel.scrollIntoView({block: 'start'});
    });
    window.addEventListener('hashchange', syncApplicationPanel);
    syncApplicationPanel();
  }

  const showState = (status) => {
    if (!state || !['approved', 'rejected', 'pending'].includes(status)) return;
    const content = status === 'approved'
      ? ['Solicitud aprobada', 'Tu solicitud está aprobada. Si todavía no puedes entrar, cierra sesión y vuelve a iniciar sesión con el email de tu solicitud para actualizar el acceso.']
      : status === 'rejected'
        ? ['Acceso profesional denegado', 'Tu cuenta particular sigue disponible, pero no tiene acceso al catálogo profesional.']
        : ['A la espera de aprobación por Miss Earrings', 'Hemos recibido tu solicitud. Podrás usar el área profesional cuando Miss Earrings la apruebe.'];
    state.innerHTML = `<strong>${content[0]}</strong><p>${content[1]}</p>`;
    state.hidden = false;
    form.hidden = true;
    if (notice) {
      notice.querySelector('[data-access-notice-title]').textContent = content[0];
      notice.querySelector('[data-access-notice-copy]').textContent = content[1];
    }
  };

  if (form.dataset.authenticated === 'true') {
    fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((body) => body && showState(body.status))
      .catch(() => {});
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    submit.disabled = true;
    message.textContent = 'Enviando solicitud…';
    const data = new FormData(form);
    const province = form.elements.provinceCode?.selectedOptions?.[0]?.textContent || '';
    const payload = Object.fromEntries(data.entries());
    payload.province = province;
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.message || 'No hemos podido guardar la solicitud.');
      message.textContent = '';
      showState(body.status);
    } catch (error) {
      message.textContent = error.message;
      submit.disabled = false;
    }
  });
})();
